import styled from '@emotion/styled';
import Autocomplete from '@mui/material/Autocomplete';
import { colors } from 'theme/colors';

export const StyledInnerWrapper = styled.div`
  font-size: 14px;
  height: 32px;

  & .MuiOutlinedInput-root {
    width: 100%;
    height: 32px;
    padding: 0;
    background-color: ${colors.white};

    & fieldset {
      border-color: ${colors.gray400};
      border-width: 1px;
    }

    &:hover:not(.Mui-focused, .Mui-disabled) fieldset {
      border-color: ${colors.primary400};
    }

    &.Mui-focused fieldset {
      border-color: ${colors.primary400};
      border-width: 2px;
    }

    &:active fieldset {
      border-color: ${colors.primary900};
      border-width: 1px;
    }

    &.Mui-error fieldset {
      border-color: ${colors.error800};
      border-width: 1px;
    }
  }

  & .MuiSelect-select {
    font-size: 14px;
    height: 32px;
    box-sizing: border-box;
    background-color: ${colors.white};
  }
`;

export const StyledAutocomplete = styled(Autocomplete)({
  '.Mui-disabled': {
    background: `${colors.gray100} !important`,
    '& input': {
      color: colors.gray400,
      background: `${colors.gray100} !important`,
    },
  },
});
